var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpec1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5879_285634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "#E2E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 67,
    width: 62,
    height: 16,
    rx: 2,
    fill: "#F47721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9541 79H75.4404V73.1211H73.502V71.8613H78.8926V73.1211H76.9541V79ZM85.3613 79L84.8438 77.3008H82.2412L81.7236 79H80.0928L82.6123 71.832H84.4629L86.9922 79H85.3613ZM84.4824 76.0312C84.0039 74.4915 83.7337 73.6208 83.6719 73.4189C83.6133 73.2171 83.571 73.0576 83.5449 72.9404C83.4375 73.3571 83.1299 74.3874 82.6221 76.0312H84.4824ZM91.6055 74.9912H94.4375V78.6924C93.9785 78.8421 93.5456 78.9463 93.1387 79.0049C92.735 79.0667 92.3216 79.0977 91.8984 79.0977C90.821 79.0977 89.9974 78.7819 89.4277 78.1504C88.8613 77.5156 88.5781 76.6058 88.5781 75.4209C88.5781 74.2686 88.9069 73.3701 89.5645 72.7256C90.2253 72.0811 91.14 71.7588 92.3086 71.7588C93.041 71.7588 93.7474 71.9053 94.4277 72.1982L93.9248 73.4092C93.404 73.1488 92.862 73.0186 92.2988 73.0186C91.6445 73.0186 91.1204 73.2383 90.7266 73.6777C90.3327 74.1172 90.1357 74.708 90.1357 75.4502C90.1357 76.2249 90.2936 76.8174 90.6094 77.2275C90.9284 77.6344 91.3906 77.8379 91.9961 77.8379C92.3118 77.8379 92.6325 77.8053 92.958 77.7402V76.251H91.6055V74.9912ZM103.493 79H101.979V73.1211H100.041V71.8613H105.432V73.1211H103.493V79ZM111.642 79H107.53V71.8613H111.642V73.1016H109.044V74.6689H111.461V75.9092H109.044V77.75H111.642V79ZM119.907 79H118.179L116.519 76.2998L114.858 79H113.237L115.605 75.3184L113.389 71.8613H115.059L116.597 74.4297L118.105 71.8613H119.736L117.495 75.4014L119.907 79ZM124.56 79H123.046V73.1211H121.107V71.8613H126.498V73.1211H124.56V79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.5,
    y1: -3,
    x2: 69.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.5,
    y1: -3,
    x2: 126.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5,
    y1: -3,
    x2: 73.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.5,
    y1: -3,
    x2: 130.5,
    y2: 150,
    stroke: "#01BFA5",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 18,
    transform: "translate(65 33)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.166 43.6572H74.5469V44.6895H73.166V47H71.8945V44.6895H67.3623V43.9443L71.8193 37.0469H73.166V43.6572ZM68.7979 43.6572H71.8945V38.7764L71.7441 39.0498L68.7979 43.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 18,
    transform: "translate(122 33)",
    fill: "#01BFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.166 43.6572H131.547V44.6895H130.166V47H128.895V44.6895H124.362V43.9443L128.819 37.0469H130.166V43.6572ZM125.798 43.6572H128.895V38.7764L128.744 39.0498L125.798 43.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 67.5,
    x2: 200,
    y2: 67.5,
    stroke: "#2A7AFF",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 82.5,
    x2: 200,
    y2: 82.5,
    stroke: "#2A7AFF",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    transform: "translate(157 66)",
    fill: "#2A7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.983 80H162.712V71.5713L160.162 72.5078V71.3594L163.785 69.999H163.983V80ZM172.651 70.04V71.1133H172.419C171.435 71.1315 170.651 71.4232 170.067 71.9883C169.484 72.5534 169.147 73.3486 169.056 74.374C169.58 73.7725 170.295 73.4717 171.202 73.4717C172.068 73.4717 172.758 73.777 173.273 74.3877C173.793 74.9984 174.053 75.7868 174.053 76.7529C174.053 77.7783 173.772 78.5986 173.212 79.2139C172.656 79.8291 171.909 80.1367 170.97 80.1367C170.017 80.1367 169.245 79.7721 168.652 79.043C168.06 78.3092 167.764 77.3659 167.764 76.2129V75.7275C167.764 73.8955 168.153 72.4964 168.933 71.5303C169.716 70.5596 170.881 70.0628 172.426 70.04H172.651ZM170.99 74.5244C170.557 74.5244 170.159 74.6543 169.794 74.9141C169.429 75.1738 169.176 75.4997 169.035 75.8916V76.3564C169.035 77.1768 169.22 77.8376 169.589 78.3389C169.958 78.8402 170.418 79.0908 170.97 79.0908C171.539 79.0908 171.986 78.8812 172.31 78.4619C172.638 78.0426 172.802 77.4935 172.802 76.8145C172.802 76.1309 172.635 75.5794 172.303 75.1602C171.975 74.7363 171.537 74.5244 170.99 74.5244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5879_285634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpec1);
export default __webpack_public_path__ + "static/media/spec-1.b7e5fc092b737bc7006a377dd56677a3.svg";
export { ForwardRef as ReactComponent };